import {Box, Button, Tooltip} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import Typography from "@mui/material/Typography";
import CheckIcon from "@mui/icons-material/Check";
import MenuItem from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import FileUploadController from "../../../API/organization/FileUploadController";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import DetailService from "../../../API/orders/cutting/detail/DetailService";
import DetailTable from "../../../components/UI/table/cutting/details/DetailTable";
import UploadFilesRequestsForm from "../../organization/orders/estimate/UploadFilesRequestsForm";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import DetailUtil from "../../../utils/cutting/DetailUtil";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import DetailCompositionController from "../../../API/organization/DetailCompositionController";
import {withFilter} from "../../../data/FilterTables/withFilterHOC";
import {DetailFilterData} from "../../../data/FilterTables/DetailFilterData";
import {compositionMaterialType} from "../../../data/CompositionMaterialType";
import {compositionModelSeries} from "../../../data/CompositionModelSeries";
const ComponentDetailWithFilter = withFilter(DetailTable, DetailFilterData);

/** GET /model и /for-composition иногда отдают массив, иногда Page {content}. */
const normalizeDetailsList = (payload) => {
    if (Array.isArray(payload)) {
        return payload;
    }
    if (payload && typeof payload === "object") {
        if (Array.isArray(payload.content)) {
            return payload.content;
        }
        if (Array.isArray(payload.details)) {
            return payload.details;
        }
    }
    return [];
};

const DetailModels = ({handleModalAlert, itemId, setIsPaperSelection}) => {
    const name = itemId === "moduleDetails" ? "Детали модулей" : "Детали моделей"
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [isError, setIsError] = useState(false);
    const [unableCut, setUnableCut] = useState({});
    const [unableTurn, setUnableTurn] = useState({});
    const [selectedIds, setSelectedIds] = useState([]);
    const [rowSelection, setRowSelection] = useState([]);
    const [modalStatusOpen, setModalStatusOpen] = useState(false);
    const [status, setStatus] = useState(true);
    const [typeStatus, setTypeStatus] = useState(null);
    const [change, setChange] = useState(false);
    const [tab, setTab] = useState(1);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [formState, setFormState] = useState({modelSeries: "", materialName: "", compositionMaterialType: ""})

    useEffect(() => {
        setIsPaperSelection?.(rowSelection.length > 0)
    }, [rowSelection, setIsPaperSelection])

    const imports = [
        {
            id: 1,
            helpText: "Импорт деталей из файлов КДТ",
            multiple: true,
            upload: (file) => itemId === "moduleDetails"
                ? DetailCompositionController.upload(file, formState.modelSeries, formState.compositionMaterialType)
                : FileUploadController.uploadModelEstimateFilesKDT(file, formState.modelSeries, formState.materialName)
        },
        {
            id: 2,
            helpText: "Импорт деталей из файла(базис раскроя)",
            multiple: true,
            upload: FileUploadController.uploadModelEstimateFiles
        },
    ]
    const handleChange = (event, newValue) => {
        setTab(newValue);
    };
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const params = useParams();

    useEffect(() => {
        getStartPageSize()
        const fetchDetails = itemId === "moduleDetails"
            ? DetailCompositionController.get()
            : DetailService.getModelDetails()

        let cancelled = false
        fetchDetails
            .then(function (response) {
                if (cancelled) {
                    return
                }
                const rows = normalizeDetailsList(response?.data)
                const error = DetailUtil.checkDuplicatePositions(rows, false);
                setIsError(error.length > 0);
                setData(rows);
                setTableOptions((prev) => ({...prev, totalElements: rows.length}))
                const nextUnableCut = {}
                const nextUnableTurn = {}
                rows.forEach((row) => {
                    nextUnableCut[row.id] = row.cut;
                    nextUnableTurn[row.id] = row.turn;
                });
                setUnableCut(nextUnableCut)
                setUnableTurn(nextUnableTurn)
            })
            .catch(function (error) {
                if (!cancelled) {
                    handleModalAlert(error);
                }
            });
        return () => {
            cancelled = true
        }
    }, [change, itemId]);


    return (
        <Box sx={{maxWidth: "2200px", padding: "0 30px"}}>
            <Typography sx={{fontSize: "24px", fontWeight: 700, paddingBottom: "30px"}}>{name}</Typography>
            <ButtonGroupTabBar activeTab={tab}>
                <Button tabIndex={1} onClick={(e) => handleChange(e, 1)}>
                    <CheckIcon/>
                    Детали
                </Button>
                <Button tabIndex={2} onClick={(e) => handleChange(e, 2)}>
                    <CheckIcon/>
                    Импорт
                </Button>
            </ButtonGroupTabBar>
            {tab === 1 ? <ComponentDetailWithFilter
                data={data}
                setData={setData}
                isError={isError}
                unableCut={unableCut}
                unableTurn={unableTurn}
                setUnableCut={setUnableCut}
                setUnableTurn={setUnableTurn}
                selectedIds={selectedIds}
                setSelectedIds={setSelectedIds}
                rowSelection={rowSelection}
                setRowSelection={setRowSelection}
                enableRowSelection
                modalStatusOpen={modalStatusOpen}
                setModalStatusOpen={setModalStatusOpen}
                status={status}
                setStatus={setStatus}
                typeStatus={typeStatus}
                setTypeStatus={setTypeStatus}
                isColumnMaterial={false}
                isColumnOrder={false}
                isDetailModel={true}
                isButtonAddDetail={true}
                warehouse={'orders'}
                enableGrouping={false}
                columnGrouping={[]}
                expanded={false}
                enableEditing={true}
                change={change}
                setChange={setChange}
                handleModalAlert={handleModalAlert}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                settings={true}
                composition={itemId === "moduleDetails"}
            /> : <Box sx={{paddingTop: "30px", display: "flex", flexDirection: "column", gap: "10px"}}>
                <Box>
                    <Box sx={{display: "flex", gap: "10px", alignItems: "center"}}>
                        <Box sx={{width: "350px", height: 70}}>
                            {itemId === "moduleDetails" ? (
                                <Autocomplete
                                    freeSolo
                                    forcePopupIcon
                                    openOnFocus
                                    options={compositionModelSeries}
                                    inputValue={formState?.modelSeries ?? ""}
                                    onInputChange={(_, value) => setFormState((prev) => ({
                                        ...prev,
                                        modelSeries: value ?? ""
                                    }))}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Серия"
                                            size="small"
                                            margin="dense"
                                        />
                                    )}
                                />
                            ) : (
                                <TextFieldValidation
                                    name={"modelSeries"}
                                    value={formState?.modelSeries}
                                    label="Серия"
                                    setCurrValues={setFormState}
                                />
                            )}
                        </Box>
                        <Tooltip sx={{height: "36px"}} arrow placement="top"
                                 title={"Обязательное поля для импорта из файлов КДТ"}>
                            <HelpOutlineIcon/>
                        </Tooltip>
                    </Box>
                    <Box sx={{display: "flex", gap: "10px", alignItems: "center"}}>
                        <Box sx={{width: "350px"}}>
                            {itemId === "moduleDetails" ? (
                                <TextFieldValidation
                                    select
                                    name={"compositionMaterialType"}
                                    value={formState?.compositionMaterialType}
                                    label="Наименование материала"
                                    setCurrValues={setFormState}
                                >
                                    {Object.entries(compositionMaterialType).map(([value, label]) => (
                                        <MenuItem key={value} value={value}>
                                            {label}
                                        </MenuItem>
                                    ))}
                                </TextFieldValidation>
                            ) : (
                                <TextFieldValidation
                                    name={"materialName"}
                                    value={formState?.materialName}
                                    label="Наименование материала"
                                    setCurrValues={setFormState}
                                />
                            )}
                        </Box>
                        <Tooltip sx={{height: "36px"}} arrow placement="top"
                                 title={"Обязательное поля для импорта из файлов КДТ"}>
                            <HelpOutlineIcon/>
                        </Tooltip>
                    </Box>
                </Box>
                <Box>
                    {itemId === "moduleDetails" ? <UploadFilesRequestsForm
                        key={imports[0].id}
                        uploadData={imports[0]}
                        detail={true}
                        change={change}
                        setChange={setChange}
                        multiple={imports[0].multiple}
                        handleModalAlert={handleModalAlert}
                        disableImport={imports[0].id === 1 && (formState.modelSeries.length === 0 || formState.compositionMaterialType.length === 0)}
                    /> : imports.map(el => {
                        return <UploadFilesRequestsForm
                            key={el.id}
                            uploadData={el}
                            detail={true}
                            change={change}
                            setChange={setChange}
                            upload={el.upload}
                            multiple={el.multiple}
                            handleModalAlert={handleModalAlert}
                            disableImport={el.id === 1 && (formState.modelSeries.length === 0 || formState.materialName.length === 0)}
                        />
                    })}
                </Box>
            </Box>}
        </Box>
    );
};

export default DetailModels;